if ($(window).width() > 768) {
  
  const menuItemsWithChildren = document.querySelectorAll('.menu-item-has-children');
  let subMenuActive = false;

  menuItemsWithChildren.forEach((item) => {
    const subMenu = item.children[1];
    let hovering = false;

    item.addEventListener('mouseenter', () => {
      if (subMenuActive) {
        menuItemsWithChildren.forEach((subItem) => {
          subItem.classList.remove('active');
        });
      }
      subMenu.classList.add('active');
      subMenuActive = true;
    });

    item.addEventListener('mouseover', () => {
      hovering = true;
    });

    item.addEventListener('mouseleave', () => {
      setTimeout(() => {
        if (!hovering) {
          subMenu.classList.remove('active');
          subMenuActive = false;
        }
      }, 500);

      hovering = false;
    });
  });
}
